import styled from "styled-components";

const RecallPageWrap = styled.div`
  padding: 0px 0 50px;
`

export default RecallPageWrap
